import { render, staticRenderFns } from "./PasteCapturer.vue?vue&type=template&id=408528ea&scoped=true"
import script from "./PasteCapturer.vue?vue&type=script&lang=js"
export * from "./PasteCapturer.vue?vue&type=script&lang=js"
import style0 from "./PasteCapturer.vue?vue&type=style&index=0&id=408528ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408528ea",
  null
  
)

export default component.exports